import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, Routes, useLocation } from "react-router-dom";

import { WindowTitle } from "../../components/WindowTitle";
import OrderLinesListComponent from "./views/OrderLinesList";

const OrderLinesList: React.FC = () => {
  const location = useLocation();
  const params = parseQs(location.search.substr(1));

  return <OrderLinesListComponent params={params} />;
};

const Component = () => {
  const intl = useIntl();
  return (
    <>
      <WindowTitle
        title={intl.formatMessage({
          defaultMessage: "Order Lines",
          description: "order lines section"
        })}
      />
      <Routes>
        <Route path={""} element={<OrderLinesList />} />
      </Routes>
    </>
  );
};

export default Component;
